// components/wizard/Disclosures.jsx
import React, { useState, useEffect } from 'react';
import { Loader } from 'lucide-react';

const Disclosures = ({ formData, updateFormData, onNext, onBack, saving }) => {
  const [allChecked, setAllChecked] = useState(false);

  const disclosures = [
    {
      id: 'd1',
      text: 'I confirm that the manuscript has been submitted solely to ASFIRJ and is not published, in press, or submitted elsewhere, with exception of submission to preprint servers.'
    },
    {
      id: 'd2',
      text: 'I am aware that ASFIRJ requires that all authors disclose all potential sources of conflict of interest in regarding the submitted manuscript and I confirm that all authors have done so.'
    },
    {
      id: 'd3',
      text: 'I confirm that the research that yielded the manuscript being submitted meets the ethical guidelines and adheres to all legal research requirements of the study country.'
    },
    {
      id: 'd4',
      text: 'I have prepared my manuscript and files, including text, tables, and figures, in accordance with ASFIRJ\'s style and formatting requirements as described at: asfirj.org/authors.html.'
    },
    {
      id: 'd5',
      text: 'I confirm that each of the co-authors acknowledges their participation in the research that yielded the manuscript being submitted and agrees to the submission of the manuscript to ASFIRJ.'
    },
    {
      id: 'd6',
      text: 'I confirm that the contributions each author made to the manuscript are specified in the authors\' contribution section of the manuscript.'
    },
    {
      id: 'd7',
      text: 'I confirm that the manuscript being submitted and the data it contains are unpublished and original.'
    },
    {
      id: 'd8',
      text: 'I confirm that I am willing to pay ASFIRJ\'s APC for the submitted manuscript if it is accepted for publication in the journal as indicated at asfirj.org/aboutus.html.'
    }
  ];

  useEffect(() => {
    const checked = disclosures.every(d => formData.disclosures[d.id]);
    setAllChecked(checked);
  }, [formData.disclosures]);

  const handleCheckboxChange = (id) => {
    updateFormData({
      disclosures: {
        ...formData.disclosures,
        [id]: !formData.disclosures[id]
      }
    });
  };

  const handleSubmit = () => {
    if (saving) return;
    if (allChecked) {
      onNext();
    }
  };

  return (
    <div>
      <h3 className="text-xl font-semibold mb-6">Disclosures</h3>

      <div className="space-y-4 mb-8">
        {disclosures.map((disclosure) => (
          <div
            key={disclosure.id}
            className={`p-4 border rounded-lg transition-colors ${
              formData.disclosures[disclosure.id]
                ? 'bg-green-50 border-green-200'
                : 'bg-gray-50 border-gray-200'
            }`}
          >
            <label className="flex items-start space-x-3 cursor-pointer">
              <input
                type="checkbox"
                checked={formData.disclosures[disclosure.id]}
                onChange={() => handleCheckboxChange(disclosure.id)}
                className="mt-1 w-4 h-4 text-[--asfi-blue] rounded focus:ring-[--asfi-blue]"
              />
              <span className="text-sm text-gray-700">
                <span className="text-red-500 mr-1">*</span>
                {disclosure.text}
              </span>
            </label>
          </div>
        ))}
      </div>

      <p className="text-sm text-red-500 mb-6">* Indicates Mandatory Fields</p>

      <div className="flex justify-between">
        <button
          onClick={onBack}
          className="px-8 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
        >
          Back
        </button>
        
        <button
          onClick={handleSubmit}
          disabled={saving || !allChecked}
          className={`px-8 py-3 rounded-lg ${
            allChecked && !saving
              ? 'bg-[--asfi-blue] text-white hover:bg-purple-700'
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }`}
        >
          {saving ? (
            <>
              <Loader className="w-4 h-4 animate-spin inline mr-2" />
              Saving...
            </>
          ) : (
            'Review & Submit'
          )}
        </button>
      </div>
    </div>
  );
};

export default Disclosures;
